interface HeroSectionProps {
  className?: string
}

export default function HeroSection({ className = '' }: HeroSectionProps) {
  return (
    <section 
      id="hero" 
      className={`min-h-screen flex items-center justify-center text-center px-6 relative ${className}`}
    >
      {/* Content overlay for better visibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/30 pointer-events-none" />
      
      <div className="relative z-10 max-w-4xl mx-auto">
        <h1 className="hero-title text-5xl md:text-7xl font-bold mb-6 animate-fade-in">
          Next-Gen
          <span className="text-gradient block md:inline md:ml-4">
            Experiences
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-200 mb-8 animate-slide-up max-w-3xl mx-auto leading-relaxed">
          Immerse yourself in cutting-edge React Three Fiber experiences that push the boundaries of web technology
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up">
          <button className="px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full hover:shadow-2xl hover:shadow-blue-500/25 transition-all duration-300 transform hover:scale-105 font-semibold text-lg">
            Explore the Experience
          </button>
          <button className="px-8 py-4 glass-effect rounded-full hover:bg-white/20 transition-all duration-300 text-lg border border-white/30">
            View Portfolio
          </button>
        </div>
        
      </div>
    </section>
  )
}
